import Vue from 'vue' // 引入vue
import VueI18n from 'vue-i18n' // 引入i18n模块
import { Cookie } from '@yld/yun-utils-common'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui英文包
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui中文包
import locale from 'element-ui/lib/locale' // 引入elementuiui语言包模块
// import enLocale from './en' // 本地英文包
// import zhLocale from './zn' // 本地中文包
import * as Util from './util'

Vue.use(VueI18n) // vue使用i18n模块

// 引入本地
const messages = {
  en: {
    ...elementEnLocale,
    msg: null
  },
  zh_CN: {
    ...elementZhLocale,
    msg: null
  }
}
// 创建国际化实例
const i18n = new VueI18n({
  locale: Cookie.getCookie(Util.getLangKey(), null, false) || 'en',
  messages, // set locale messages。语言包
  silentTranslationWarn: true // 屏蔽翻译在控制台报出的警告
})
locale.i18n((key, value) => i18n.t(key, value))
export default i18n
